<script setup lang="ts">
import { computed } from 'vue'

import {
  BasketballIncidentId,
  BasketballStatId,
  Participant,
} from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables'
import PitchIncidentButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidentButton/PitchIncidentButton.vue'

interface Props {
  participant: Participant
}

const props = defineProps<Props>()

const { event } = useEvent()

const foulBonusSelected = computed(() =>
  props.participant.stats?.some(
    ({ id, value }) => id === BasketballStatId.FoulBonus && value === '1',
  ),
)

async function onClick(addIncident: () => void): Promise<void> {
  if (foulBonusSelected.value) {
    await sportsApiClient.Events.Participants.patch(event.value.id, [
      {
        id: props.participant.id,
        stats: [
          {
            id: BasketballStatId.FoulBonus,
            value: '0',
          },
        ],
      },
    ])
    return
  }

  addIncident()
}
</script>

<template>
  <PitchIncidentButton
    class="hover:bg-error-8 active:bg-error-3 active:text-neutral-light-10"
    :class="{
      'enabled:bg-error-3 enabled:text-neutral-light-10': foulBonusSelected,
    }"
    :participant
    name="FB"
    :incidentId="BasketballIncidentId.FoulBonus"
    @click="onClick"
  />
</template>
